import React, { useState, useEffect } from "react";
import Profile from "./Profile";
import { useAccount } from "wagmi";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";
import axios from "axios";
import { useSigner } from "wagmi";
import { ethers } from "ethers";
import { SubscriptionAddress } from "./Contracts/Subscription";
import { SubscriptionAbi } from "./Contracts/Subscription";
import { BoxAddress } from "./Contracts/Box";
import { BoxAbi } from "./Contracts/Box";
import { getMagic, getMagic1 } from "./web3";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import Loading from "./Loading";
import { useNavigate } from "react-router-dom";
import { FaCopy } from "react-icons/fa";

const Requests = () => {
  const navigate = useNavigate();
  const { data: signer } = useSigner();
  const { BigNumber } = require("ethers");
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState(false);
  const [invitationid, setInvitationid] = useState();
  console.log("invitation", invitationid);
  const { address } = useAccount();
  const token = localStorage.getItem("token");
  console.log("STATUS", status);
  console.log("Token", token);
  let userData = JSON.parse(localStorage.getItem("userData"));
  console.log("User", userData);
  let walletAddress = userData?.walletAddress;

  let contract;
  let boxcontract;
  // if (signer) {
  //   boxcontract = new ethers.Contract(localStorage.getItem("newaddress"), BoxAbi, signer);
  //   console.log("BOX",boxcontract);
  // }

  if (signer) {
    contract = new ethers.Contract(
      SubscriptionAddress,
      SubscriptionAbi,
      signer
    );
  }
  const get_Invitations = async () => {
    if (token == undefined) {
      setIsLoading(false);
      // console.error("Error logging in:", error);
      localStorage.setItem("reload", true);
      navigate("/#");
    } else {
      // try {
      // await axios
      //   .get(`${process.env.REACT_APP_SERVER_URL}/payment-history`, {
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //     },
      //   })

      // .then(async(ress) => {

      const res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/invite`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Resuktttttttttttttt", res);
      if (res.data.success) {
        console.log("Successfuly ", res?.data);
        //   alert(res.data.msg);
        setList(res?.data.data);
      } else {
        console.log("error ", res.data.msg);
        //   alert(res.data.msg);
      }
      // }
      // );
      // } catch (error) {
      //   setIsLoading(false);
      //   console.error("Error logging in:", error);
      //   localStorage.setItem("reload", true);
      //   navigate("/#");
    }
  };
  const verify_invitation = async (ids, statuses, address, box, index) => {
    let signerr;
    let provider;
    if (localStorage.getItem("isMagic") == "true") {
      console.log("INNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN");
      let [magicSigner, magicProvider] = getMagic1();
      signerr = magicSigner;
      provider = magicProvider;
      console.log("Magicccccccccccccccc", magicSigner, magicProvider);
    } else {
      signerr = signer;
    }
    console.log("ids", ids, index);
    console.log("statuses", statuses);
    const res = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}/verify-invitation`,
      { invitationId: ids, status: statuses },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    boxcontract = new ethers.Contract(box, BoxAbi, signerr);
    if (res.data.success) {
      setIsLoading(true);

      console.log("Successfuly ", res.data.msg);
      console.log("box", boxcontract);
      console.log("Address", box, address, index);
      if (statuses == "accepted") {
        console.log("accept");
        await boxcontract.requestAccept(address).then(async (res) => {
          await res.wait().then((tx) => {
            setIsLoading(false);
            // alert("Successssssssss accepted")
          });
        });
      }
      if (statuses == "rejected") {
        console.log("reject");
        await boxcontract.requestReject(address).then(async (res) => {
          await res.wait().then((r) => {
            console.log("re", r);
            setIsLoading(false);
          });
          // alert("Successssssssss rejected")
        });
      }
      setStatus(!status);
      //   alert(res.data.msg);
    } else {
      console.log("errorsdfg ", res.data);
      setIsLoading(false);
      //  alert(res.data.msg);
    }
  };
  console.log("LIST", list);
  // const requestAccess = async () => {
  //   await boxcontract.requestAccept().then((res) => {
  //     //   const storage = BigNumber.from(res);
  //     //   const totalstorage = storage.toString();
  //     //   const round = totalstorage / 1024;
  //     //   const sizeMb = round.toFixed(2);
  //     //   setUsedStorage(sizeMb);
  //     console.log("LISTS", res);
  //   });
  // };
  useEffect(() => {
    // if (signer) {
    get_Invitations();
    // }
  }, [status]);
  return (
    <>
      {/* <Toaster position="top-center" reverseOrder={false} /> */}
      <div className="antialiased bg-[#212445] w-full min-h-screen text-slate-300 relative py-4">
        <div className="grid grid-cols-12 mx-auto gap-2 sm:gap-4 md:gap-6 lg:gap-10 xl:gap-14 max-w-7xl  my-10 px-2">
          <Profile />
          <div className=" w-full">
            <h1 className="text-3xl text-white my-10">Users</h1>
            {list.map((item, index) => {
              return (
                <div
                  className="md:flex md:items-center md:gap-2 lg:gap-4 mt-3 border-b-[1px] w-fit py-2"
                  key={index}
                >
                  <div className="">
                    <h1 className="md:my-auto lg:w-[250px] md:w-[150px] w-[300px]">
                      <span className="font-medium">Email:</span> {item?.email}
                    </h1>
                    {/* <h1 className="my-auto w-[350px]">Created At: {item.createdAt}</h1> */}
                  </div>
                  <div className=" md:ml-10">
                    <div className=" md:ml-10">
                      {/* <h1 className="my-auto w-[200px]">Box: {item.boxAddress.slice(1,4)+"..."+item.boxAddress.slice(-3,-1)}</h1> */}
                      <h1 className="md:my-auto w-[120px]">
                        <span className="font-medium">Wallet:</span>{" "}
                        {item?.walletAddress.slice(0, 4) +
                          "..." +
                          item?.walletAddress.slice(-4)}
                      </h1>
                    </div>

                    <div className=" md:ml-10">
                      {/* <h1 className="my-auto w-[200px]">Box: {item.boxAddress.slice(1,4)+"..."+item.boxAddress.slice(-3,-1)}</h1> */}
                      <h1 className="md:my-auto w-[120px] lg:w-[200px]">
                        <span className="font-medium">Box:</span>{" "}
                        {item?.boxAddress.slice(0, 4) +
                          "..." +
                          item?.boxAddress.slice(-3, -1)}
                      </h1>
                    </div>
                  </div>
                  <div className="font-semibold">
                    {item.status == "accepted" ? (
                      "Accepted"
                    ) : item.status == "rejected" ? (
                      "Rejected"
                    ) : (
                      <div className="md:flex">
                        <button
                          className="bg-green-500 p-3 rounded-xl m-2"
                          onClick={() =>
                            verify_invitation(
                              item?._id,
                              "accepted",
                              item?.walletAddress,
                              item?.boxAddress,
                              item?.index
                            )
                          }
                        >
                          Accept
                        </button>
                        <button
                          className="bg-red-400 p-3 rounded-xl m-2 "
                          onClick={() =>
                            verify_invitation(
                              item?._id,
                              "rejected",
                              item?.walletAddress,
                              item?.boxAddress,
                              item?.index
                            )
                          }
                        >
                          Reject
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div
        onClick={() => {
          // console.log(localStorage.getItem("token"))
          // localStorage.clear()
          // window.location.reload();
          localStorage.setItem("reload", true);
          navigate("/#");
        }}
        className="absolute bottom-4 left-4 text-white bg-black px-3 py-1 rounded-sm cursor-pointer"
      >
        Logout
      </div>

      {localStorage.getItem("isMagic") == "false" ? (
        <div className="  px-5 text-white absolute top-2 right-8">
          <ConnectButton className="" />
        </div>
      ) : (
          
        <div
        onClick={async () => {
          navigator.clipboard.writeText(walletAddress.toString());
        }}
        className=" bg-white rounded-sm flex gap-4 items-center px-5 text-black text-lg cursor-pointer absolute top-2 right-8"
      >
        <FaCopy />
        {localStorage.getItem("walletBalance")> 0.001 ? localStorage.getItem("walletBalance") + "ETH": "Insufficient Balance"}
      </div>
      )}
      <Loading isLoading={isLoading} />
    </>
  );
};

export default Requests;
